import { gql } from "@apollo/client";

export const PERMISSION_CREATE = gql`
  mutation PermissionCreate($input: PermissionFieldsInput!) {
    permissionCreate(input: $input) {
      label
      message
      permission {
        id
        slug
        entry_point
        group_name
        action
        translation(lang: "en") {
          id
          group_name
          lang
          slug
          value
          editable
          img_path
          order
          created_at
          updated_at
        }
        created_at
        updated_at
      }
    }
  }
`;

export const PERMISSION_UPDATE = gql`
  mutation PermissionUpdate($input: PermissionFieldsInput!) {
    permissionUpdate(input: $input) {
      label
      message
      permission {
        id
        slug
        entry_point
        group_name
        action
        translation(lang: "en") {
          id
          group_name
          lang
          slug
          value
          editable
          img_path
          order
          created_at
          updated_at
        }
        created_at
        updated_at
      }
    }
  }
`;

export const PERMISSION_DELETE = gql`
  mutation PermissionDelete($id: ID!) {
    permissionDelete(id: $id) {
      label
      message
    }
  }
`;